import { z } from "zod";

export const newTableSchema = z.object({
  id: z.string().trim().optional(),
  table_display_name: z
    .string()
    .trim()
    .nonempty("El nombre de la tabla es requerido")
    .max(100, "Máximo 100 caracteres"),
  description: z
    .string()
    .trim()
    .max(500, "Máximo 500 caracteres")
    .optional()
    .prefault(""),
  name: z
    .string()
    .trim()
    .nonempty("La key es requerida")
    .regex(
      /^[a-zA-Z0-9_-]+$/,
      "La key solo puede contener letras, números, guiones y guiones bajos",
    ),
});

export const newColumnSchema = z.object({
  display_name: z
    .string()
    .trim()
    .nonempty("El nombre de la columna es requerido")
    .max(100, "Máximo 100 caracteres"),
  name: z
    .string()
    .trim()
    .nonempty("La key de la columna es requerido")
    .regex(
      /^[a-zA-Z0-9_-]+$/,
      "La key solo puede contener letras, números, guiones y guiones bajos",
    )
    .max(100, "Máximo 100 caracteres"),
  data_type: z
    .enum(["STRING", "INTEGER", "BOOLEAN", "LIST", "MLIST", "FLOAT"])
    .prefault("STRING"),
});

export type TableData = z.infer<typeof newTableSchema>;
export type ColumnData = z.infer<typeof newColumnSchema>;
